export const SAVED_LIST_ITEM_COUNT = 12;
export const ICON_SIZE = 24;
export const PLUS_ICON_SIZE = 20;
export const TRUE_VALUE = 'true';
export const FALSE_VALUE = 'false';
